module.exports = __webpack_public_path__ + "static/media/luiz_antonio_tozi.906e71bc.png";